import { useDispatch } from "react-redux";
import "./style.css"
import { setMessage } from "../../redux";

function Signup({ form, setForm, setAccess }) {
    const dispatch = useDispatch();

    const signup = async (e) => {
        e.preventDefault();
        dispatch(setMessage('Chargement en cours, merci de patienter'));

        const req = await fetch(`${process.env.REACT_APP_API_URL}/wlist/access/${form.email}`);
        const res = await req.json();
        dispatch(setMessage());

        if (req.status !== 200) {
            alert(res.message);
            return;
        }
        setAccess(true);
    };

    return (
        <form className="form_verif_signup" onSubmit={signup}>
            <h1>S'identifier</h1>

            <div className="blocks">
                <div className="inp_block">
                    <label>Email</label>
                    <input
                        type="text"
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                    />
                </div>
            </div>

            <button className="btn_submit" type="submit">Valider</button>
        </form>
    )
}

export default Signup;